/*
  FLORASA — Conversion (27 sept. 2026). Chargé en defer par snippets/fl-conversion.liquid.

  1. API partagée window.FLConv (utilisée par le popup de sortie et l'offre de la fiche produit) :
     - FLConv.applyCode(code)  -> Promise<{ok, applicable, code, codes, message, reason}>
       Fusionne avec les codes déjà dans le panier (POST /cart/update.js remplace la liste),
       lit `applicable` dans la réponse, n'envoie jamais deux fois le même code en parallèle,
       puis émet l'évènement document « fl:code-applied » (detail = le résultat).
     - FLConv.removeCode(code) -> Promise (évènement « fl:code-removed »).
     - FLConv.estimate(pays)   -> {from: Date, to: Date, range: '5 – 14 oct.', text: 'Livraison estimée : 5 – 14 oct.'}
     - FLConv.config           -> {code, pct, country, locale, freeShipThreshold, freeShipCountries, …}
     - FLConv.ready(cb), FLConv.getCart(), FLConv.scan(conteneur).
     Un script qui s'exécute avant celui-ci peut écouter l'évènement document « fl:conv-ready ».
  2. Crochets déclaratifs, partout dans la page :
     - <button type="button" data-fl-apply-code="CODE"> : applique le code ; message dans le
       [data-fl-apply-status] voisin (aria-live) ; état « appliqué ✓ ».
     - <span data-fl-delivery></span> : texte d'estimation du pays courant
       (data-fl-delivery="range" : seulement les dates).
     - <button type="button" data-fl-copy="CODE"> : copie le code, retour visuel.
  3. Tiroir panier (blocks/ai_gen_block_f31769b.liquid, non modifié) : juste au-dessus du total, les
     codes appliqués (puces, modules.drawerCodeLines) et, si modules.drawerCode, le lien « Vous avez
     un code promo ? » qui déplie le champ (coupé le 27 sept. : les codes se saisissent au paiement) ;
     au-dessus de Checkout+, la livraison estimée ; sous le bouton de paiement, la rangée de confiance.
     Le tiroir ne redessine que ses lignes et ses totaux : nos blocs vivent dans son pied de page
     et un MutationObserver (limité au tiroir, 1 passage par image) les remet s'ils disparaissent.
     Barre de livraison gratuite : le tiroir la calcule AVANT rabais de commande ; Shopify facture
     la livraison sur le total APRÈS rabais, Checkout+ compris (vérifié le 27 sept. 2026 :
     97 $ + Checkout+ 4,48 $ = livraison 0 $ ; 111 $ − 10 % = 99,90 $ = livraison 14,90 $).
     Quand un code fait repasser le panier sous le seuil, on corrige la barre (texte, étape, point).

  Aucun minuteur, aucun compteur, aucun avis : seulement des faits de la boutique (voir le snippet).
*/
(function () {
  'use strict';

  if (window.FLConv && window.FLConv.__fl) return;

  /* ---------- Réglages (snippets/fl-conversion.liquid) ---------- */
  var cfg = {};
  try {
    var cfgEl = document.getElementById('fl-conv-config');
    if (cfgEl) cfg = JSON.parse(cfgEl.textContent || '{}') || {};
  } catch (e) { cfg = {}; }
  var T = cfg.i18n || {};
  var modules = cfg.modules || {};
  var isFr = cfg.locale === 'fr';
  var intlLocale = isFr ? 'fr-CA' : 'en-CA';
  var NBSP = ' ';

  function t(key, code, vars) {
    var s = T[key] || '';
    if (code != null) s = s.split('{code}').join(String(code));
    for (var k in (vars || {})) { if (vars.hasOwnProperty(k)) s = s.split('{' + k + '}').join(String(vars[k])); }
    return s;
  }

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || cfg.root || '/';
  if (root.slice(-1) !== '/') root += '/';

  function each(list, fn) { Array.prototype.forEach.call(list || [], fn); }

  function emit(name, detail) {
    try { document.dispatchEvent(new CustomEvent(name, { detail: detail })); } catch (e) {}
  }

  /* ---------- Panier (API Ajax) ---------- */
  function jsonOrThrow(res) {
    if (!res.ok) {
      var err = new Error('HTTP ' + res.status);
      err.status = res.status;
      throw err;
    }
    return res.json();
  }
  function fetchCart() {
    return fetch(root + 'cart.js', {
      credentials: 'same-origin', cache: 'no-store',
      headers: { 'Accept': 'application/json' }
    }).then(jsonOrThrow);
  }
  /* Passe par window.fetch : le tiroir (qui le patche) se rafraîchit tout seul après /cart/update. */
  function postCodes(list) {
    return fetch(root + 'cart/update.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ discount: list.join(',') })
    }).then(jsonOrThrow);
  }

  function norm(code) { return String(code == null ? '' : code).replace(/\s+/g, ' ').trim(); }
  function same(a, b) { return String(a).toUpperCase() === String(b).toUpperCase(); }
  function codesOf(cart) {
    return ((cart && cart.discount_codes) || []).map(function (d) { return d && d.code; }).filter(Boolean);
  }
  function entryOf(cart, code) {
    var list = (cart && cart.discount_codes) || [];
    for (var i = 0; i < list.length; i++) { if (list[i] && same(list[i].code, code)) return list[i]; }
    return null;
  }
  /* État d'un code : « applied » s'il s'applique ; « saved » s'il attend dans un panier vide
     (Shopify l'appliquera au premier article) ; « idle » sinon. */
  function codeState(cart, code) {
    var e = entryOf(cart, code);
    if (!e) return 'idle';
    if (e.applicable) return 'applied';
    return cart.item_count ? 'idle' : 'saved';
  }

  var lastCart = null;

  /* File d'attente : une seule écriture à la fois ; le même appel en cours est réutilisé. */
  var queue = Promise.resolve();
  var pending = {};
  function serial(key, job) {
    if (pending[key]) return pending[key];
    var p = queue.then(job, job);
    pending[key] = p;
    queue = p.then(function () { delete pending[key]; }, function () { delete pending[key]; });
    return p;
  }

  function outcome(cart, ok, applicable, code, message, reason) {
    if (cart && cart.discount_codes) publish(cart);
    return {
      ok: ok, applicable: applicable, code: code,
      codes: codesOf(cart || lastCart), message: message, reason: reason
    };
  }
  function failure(err, code, key) {
    var net = !err || err.status == null;
    return outcome(lastCart, false, false, code, t(net ? 'msgNetwork' : key), net ? 'network' : 'http-' + err.status);
  }

  function doApply(code) {
    if (!code) return Promise.resolve(outcome(lastCart, false, false, code, t('msgEmpty'), 'empty'));
    if (code.indexOf(',') !== -1) return Promise.resolve(outcome(lastCart, false, false, code, t('msgOneCode'), 'several'));
    var isOffer = !!cfg.code && same(code, cfg.code);
    return fetchCart().then(function (cart) {
      var before = codesOf(cart).filter(function (c) { return !same(c, code); });
      var existing = entryOf(cart, code);
      if (existing && existing.applicable) {
        return outcome(cart, true, true, existing.code, t('msgAlready', existing.code), 'already');
      }
      return postCodes(before.concat([code])).then(function (after) {
        var e = entryOf(after, code);
        if (e && e.applicable) {
          /* Codes non cumulables : Shopify garde le nouveau et laisse l'ancien « non appliqué ».
             On compare le panier avant / après : l'ancien était meilleur -> on le remet et on le dit ;
             sinon on retire l'ancien (il ne resterait pas en erreur au paiement) et on le dit. */
          var lost = before.filter(function (c) {
            var b0 = entryOf(cart, c), a0 = entryOf(after, c);
            return b0 && b0.applicable && !(a0 && a0.applicable);
          });
          if (lost.length && cart.item_count) {
            var old = lost.join(', ');
            if (after.total_price > cart.total_price) {
              return postCodes(before).then(function (reverted) {
                return outcome(reverted, false, false, e.code, t('msgKeptBetter', e.code, { old: old }), 'kept-better');
              }, function () {
                return outcome(after, false, false, e.code, t('msgKeptBetter', e.code, { old: old }), 'kept-better');
              });
            }
            var keep = codesOf(after).filter(function (c) { return !lost.some(function (l) { return same(l, c); }); });
            var done = function (c2) {
              var res = outcome(c2, true, true, e.code, t('msgReplaced', e.code, { old: old }) + shipNote(cart, c2), 'applied');
              res.replaced = lost;
              return res;
            };
            return postCodes(keep).then(done, function () { return done(after); });
          }
          return outcome(after, true, true, e.code, t('msgApplied', e.code) + shipNote(cart, after), 'applied');
        }
        /* Panier vide : Shopify garde le code et l'applique au premier article (vérifié le 27 sept.).
           Seul le code des offres est gardé ; un code inconnu est retiré. */
        if (!after.item_count && isOffer) {
          return outcome(after, true, false, code, t('msgSavedEmpty', code), 'saved');
        }
        var others = ((after.discount_codes) || []).some(function (d) { return d && d.applicable && !same(d.code, code); });
        var key = !after.item_count ? 'msgNeedItem'
          : (isOffer ? (others ? 'msgNotCombinable' : 'msgNotApplicable') : 'msgInvalid');
        var reason = !after.item_count ? 'need-item' : (isOffer ? (others ? 'not-combinable' : 'not-applicable') : 'invalid');
        /* On ne laisse pas un code refusé dans le panier : il réapparaîtrait en erreur au paiement. */
        return postCodes(before).then(function (reverted) {
          return outcome(reverted, false, false, code, t(key, code), reason);
        }, function () {
          return outcome(after, false, false, code, t(key, code), reason);
        });
      });
    }).catch(function (err) { return failure(err, code, 'msgError'); });
  }

  function applyCode(code) {
    code = norm(code);
    /* Le code des offres est toujours envoyé sous sa forme officielle (MISSYOU10, pas missyou10). */
    if (cfg.code && same(code, cfg.code)) code = cfg.code;
    return serial('apply:' + code.toUpperCase(), function () {
      return doApply(code).then(function (res) { emit('fl:code-applied', res); return res; });
    });
  }

  function removeCode(code) {
    code = norm(code);
    return serial('remove:' + code.toUpperCase(), function () {
      return fetchCart().then(function (cart) {
        var codes = codesOf(cart);
        var rest = codes.filter(function (c) { return !same(c, code); });
        if (rest.length === codes.length) return outcome(cart, true, false, code, t('msgRemoved', code), 'absent');
        return postCodes(rest).then(function (after) {
          return outcome(after, true, false, code, t('msgRemoved', code), 'removed');
        });
      }).catch(function (err) { return failure(err, code, 'msgRemoveError'); })
        .then(function (res) { emit('fl:code-removed', res); return res; });
    });
  }

  /* ---------- Livraison estimée ---------- */
  /* Jours ouvrables = lun.-ven. Départ = aujourd'hui (heure de l'Est) + 1 à 3 jours ouvrables ;
     arrivée = départ + transit en jours civils ; une date qui tombe un week-end passe au lundi. */
  function todayEastern() {
    try {
      var o = {};
      new Intl.DateTimeFormat('en-CA', {
        timeZone: 'America/Toronto', year: 'numeric', month: '2-digit', day: '2-digit'
      }).formatToParts(new Date()).forEach(function (p) { o[p.type] = p.value; });
      var y = parseInt(o.year, 10), m = parseInt(o.month, 10), d = parseInt(o.day, 10);
      if (y && m && d) return new Date(Date.UTC(y, m - 1, d, 12));
    } catch (e) {}
    var n = new Date();
    return new Date(Date.UTC(n.getFullYear(), n.getMonth(), n.getDate(), 12));
  }
  function isWeekend(d) { var w = d.getUTCDay(); return w === 0 || w === 6; }
  function addDays(d, n) { var x = new Date(d.getTime()); x.setUTCDate(x.getUTCDate() + n); return x; }
  function addBusinessDays(d, n) {
    var x = new Date(d.getTime());
    while (n > 0) { x = addDays(x, 1); if (!isWeekend(x)) n--; }
    return x;
  }
  function nextWeekday(d) { var x = d; while (isWeekend(x)) x = addDays(x, 1); return x; }
  function dayMonth(d) {
    var o = { day: String(d.getUTCDate()), month: String(d.getUTCMonth() + 1) };
    try {
      new Intl.DateTimeFormat(intlLocale, { day: 'numeric', month: 'short', timeZone: 'UTC' })
        .formatToParts(d).forEach(function (p) { if (p.type === 'day' || p.type === 'month') o[p.type] = p.value; });
    } catch (e) {}
    return o;
  }
  /* « 5 – 14 oct. » / « 28 sept. – 8 oct. » ; EN « Oct 5 – 14 » / « Sep 28 – Oct 8 ». */
  function formatRange(a, b) {
    var pa = dayMonth(a), pb = dayMonth(b);
    /* Espaces insécables des deux côtés du tiret : la plage ne se coupe jamais. */
    var dash = NBSP + '–' + NBSP;
    if (a.getUTCMonth() === b.getUTCMonth() && a.getUTCFullYear() === b.getUTCFullYear()) {
      return isFr ? pa.day + dash + pb.day + NBSP + pb.month : pa.month + NBSP + pa.day + dash + pb.day;
    }
    return isFr
      ? pa.day + NBSP + pa.month + dash + pb.day + NBSP + pb.month
      : pa.month + NBSP + pa.day + dash + pb.month + NBSP + pb.day;
  }
  var estimates = {};
  function estimate(country) {
    var iso = String(country || cfg.country || 'CA').toUpperCase();
    if (estimates[iso]) return estimates[iso];
    var sh = cfg.shipping || {};
    var tr = (sh.transit && (sh.transit[iso] || sh.transit.other)) || [14, 28];
    var today = todayEastern();
    var from = nextWeekday(addDays(addBusinessDays(today, sh.prepMin || 1), tr[0]));
    var to = nextWeekday(addDays(addBusinessDays(today, sh.prepMax || 3), tr[1]));
    var range = formatRange(from, to);
    var res = { from: from, to: to, range: range, label: t('deliveryLabel'), text: t('deliveryLabel') + ' ' + range, note: t('deliveryNote') };
    estimates[iso] = res;
    return res;
  }

  /* ---------- Montants ---------- */
  /* Format des montants = celui du « CART TOTAL » rendu par le tiroir (symbole, séparateurs,
     suffixe CAD), lu dans la page : la puce du code s'écrit comme les totaux juste en dessous.
     Repli sur Intl si le total est introuvable (tiroir absent). */
  var AMT_RE = /^(\D*?)(\d(?:[\d.,\s  ']*\d)?)(\D*)$/;
  function readAmount(node) {
    var txt = node ? String(node.textContent || '').replace(/^\s+|\s+$/g, '') : '';
    var m = AMT_RE.exec(txt);
    if (!m) return null;
    var num = m[2];
    var dm = /([.,])(\d{2})$/.exec(num);
    var whole = dm ? num.slice(0, -3) : num;
    var th = (whole.match(/[^\d]/) || [''])[0];
    var cents = parseInt(whole.replace(/\D/g, '') || '0', 10) * 100 + (dm ? parseInt(dm[2], 10) : 0);
    return { pre: m[1], dec: dm ? dm[1] : '', th: th, suf: m[3], cents: cents };
  }
  function drawerFormat() {
    if (!drawer) return null;
    var tot = drawer.querySelector('[data-cd-total]');
    var co = drawer.querySelector('[data-cd-checkout-total]');
    var a = readAmount(tot) || readAmount(co);
    if (!a) return null;
    if (!a.dec) { var b = readAmount(co === tot ? null : co); if (b && b.dec) a.dec = b.dec; }
    var sufEl = tot && tot.querySelector('[class*="suffix"]');
    a.sufGap = sufEl ? getComputedStyle(sufEl).marginLeft : '';
    return a;
  }
  function intlParts() {
    var o = { pre: '', dec: '.', th: ',', suf: '' };
    try {
      var parts = new Intl.NumberFormat(intlLocale, { style: 'currency', currency: cfg.currency || 'CAD' }).formatToParts(1234.5);
      var seenNum = false;
      parts.forEach(function (p) {
        if (p.type === 'integer' || p.type === 'fraction') seenNum = true;
        else if (p.type === 'decimal') o.dec = p.value;
        else if (p.type === 'group') o.th = p.value;
        else if (p.type === 'currency' || p.type === 'literal') { if (seenNum) o.suf += p.value; else o.pre += p.value; }
      });
    } catch (e) {}
    return o;
  }
  function digits(cents, f, noDec) {
    cents = Math.abs(Math.round(Number(cents) || 0));
    var whole = String(Math.floor(cents / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, f.th || '');
    /* Comme le tiroir : les cents seulement s'il y en a (45,46 / 45). */
    return (noDec || cents % 100 === 0) ? whole : whole + (f.dec || '.') + ('0' + (cents % 100)).slice(-2);
  }
  /* Montant en nœuds DOM : [signe][symbole]45,46[<span>CAD</span>] */
  function moneyNodes(cents, sign) {
    var f = drawerFormat() || intlParts();
    var frag = document.createDocumentFragment();
    frag.appendChild(document.createTextNode((sign || '') + f.pre + digits(cents, f)));
    var suf = (f.suf || '').replace(/^\s+/, '');
    if (suf) {
      var s = el('span', 'fl-cv-cur', suf);
      if (f.sufGap) s.style.marginLeft = f.sufGap;
      frag.appendChild(s);
    }
    return frag;
  }

  /* ---------- Livraison gratuite (barre du tiroir) ---------- */
  function shipThreshold() {
    var rate = (window.Shopify && Shopify.currency && parseFloat(Shopify.currency.rate)) || 1;
    if (!(rate > 0)) rate = 1;
    return Math.round((Number(cfg.freeShipThreshold) || 0) * 100 * rate);
  }
  function shipEligible() {
    var list = cfg.freeShipCountries || [];
    return !!cfg.freeShipThreshold && list.indexOf(String(cfg.country || 'CA').toUpperCase()) !== -1;
  }
  /* « Plus que 12 $ » / « Only $12 » : arrondi au dollar supérieur, comme le texte du tiroir. */
  function shipAmt(cents) {
    var f = drawerFormat() || intlParts();
    var sym = (f.pre || '').replace(/\s+/g, '') || (f.suf || '').replace(/\s+/g, '');
    var n = digits(Math.ceil(cents / 100) * 100, f, true);
    return isFr ? n + NBSP + sym : sym + n;
  }
  /* Phrase ajoutée au message quand le code fait repasser le panier sous le seuil. */
  function shipNote(beforeCart, afterCart) {
    if (!shipEligible() || !beforeCart || !afterCart || !afterCart.item_count) return '';
    var thr = shipThreshold();
    if (beforeCart.total_price >= thr && afterCart.total_price < thr) {
      return ' ' + t('msgShipAway', null, { amt: shipAmt(thr - afterCart.total_price) });
    }
    return '';
  }
  function hasOrderDiscount(cart) {
    return !!(cart && cart.cart_level_discount_applications && cart.cart_level_discount_applications.length);
  }
  /* Le tiroir compte les articles AVANT rabais de commande (et sans Checkout+) ; Shopify, le total
     APRÈS rabais. Quand un rabais fait repasser sous le seuil, on remet la barre à l'étape 1.
     N'écrit que ce qui change (pas de boucle avec l'observateur) et seulement si le panier connu
     est bien celui affiché (même total sur le bouton de paiement). */
  function fixShipBar() {
    if (!drawer || !lastCart || !lastCart.item_count || !hasOrderDiscount(lastCart)) return;
    var bar = drawer.querySelector('[data-cd-progress]');
    if (!bar || bar.hidden) return;
    var shown = readAmount(drawer.querySelector('[data-cd-checkout-total]'));
    if (!shown || shown.cents !== lastCart.total_price) return;
    var thr = shipThreshold();
    if (!thr || lastCart.total_price >= thr) return;
    var d2 = bar.querySelector('[data-cd-pb-d2]');
    /* Le tiroir croit le seuil atteint : point 2 éteint, étape 1, remplissage au point 1 (25 %). */
    if (d2 && d2.classList.contains('is-on')) {
      d2.classList.remove('is-on');
      var fill = bar.querySelector('[data-cd-pb-fill]');
      var track = fill && fill.parentElement;
      if (track) {
        var fillCol = getComputedStyle(fill).backgroundColor;
        track.style.background = '';
        var trackCol = getComputedStyle(track).backgroundColor;
        track.style.background = 'linear-gradient(to right, ' + fillCol + ' 0%, ' + fillCol + ' 25%, ' + trackCol + ' 25%, ' + trackCol + ' 100%)';
      }
    }
    if (bar.getAttribute('data-cd-step') !== '1') bar.setAttribute('data-cd-step', '1');
    /* Le montant manquant se calcule sur le total après rabais (celui du tiroir est trop bas). */
    var txt = bar.querySelector('[data-cd-pb-text]');
    var want = t('shipAway', null, { amt: shipAmt(thr - lastCart.total_price) });
    if (txt && want && txt.textContent !== want) txt.textContent = want;
  }
  /* Rabais réel d'un code : niveau panier + niveau ligne (ex. code d'un produit offert).
     /cart.js donne {type, title, total_allocated_amount} ; /cart/update.js donne
     {amount, discount_application: {type, title, …}} : les deux formes sont lues. */
  function savingOf(cart, code) {
    var total = 0;
    each(cart.cart_level_discount_applications, function (a) {
      var app = a && (a.discount_application || a);
      if (!app || app.type !== 'discount_code' || !same(app.title, code)) return;
      total += Number(a.discount_application ? a.amount : app.total_allocated_amount) || 0;
    });
    each(cart.items, function (it) {
      each(it.line_level_discount_allocations, function (al) {
        var app = al && al.discount_application;
        if (app && app.type === 'discount_code' && same(app.title, code)) total += Number(al.amount) || 0;
      });
    });
    return total;
  }

  /* ---------- Région aria-live de secours ---------- */
  /* <span>, pas <div> : base.css (div:empty) et le pied de page (« ~ div:empty », !important)
     masquent un div vide, et une région masquée n'est pas annoncée quand elle se remplit. */
  var live = null;
  function liveRegion() {
    if (live && live.isConnected) return live;
    live = document.createElement('span');
    live.className = 'fl-cv-sr';
    live.setAttribute('role', 'status');
    live.setAttribute('aria-live', 'polite');
    document.body.appendChild(live);
    return live;
  }
  function say(el, text, state) {
    if (!el) return;
    el.textContent = '';
    if (state) el.setAttribute('data-fl-state', state); else el.removeAttribute('data-fl-state');
    /* Vider puis remplir au tour suivant : le même message répété est bien relu. */
    setTimeout(function () { el.textContent = text || ''; }, 30);
  }
  function stateOf(res) { return res.ok ? (res.applicable || res.reason === 'removed' || res.reason === 'absent' ? 'success' : 'info') : 'error'; }

  /* ---------- Crochets déclaratifs ---------- */
  function findNear(el, sel) {
    var node = el.parentElement, depth = 0;
    while (node && depth < 3) {
      var hit = node.querySelector(sel);
      if (hit) return hit;
      node = node.parentElement; depth++;
    }
    return null;
  }
  function prepLive(el) {
    if (!el.hasAttribute('aria-live')) el.setAttribute('aria-live', 'polite');
    if (!el.hasAttribute('role')) el.setAttribute('role', 'status');
  }
  /* Libellé modifiable : un enfant [data-fl-label] s'il existe, sinon le bouton s'il ne contient que du texte. */
  function labelNode(btn) {
    var l = btn.querySelector('[data-fl-label]');
    if (l) return l;
    for (var i = 0; i < btn.childNodes.length; i++) { if (btn.childNodes[i].nodeType === 1) return null; }
    return btn;
  }
  function setLabel(btn, text) {
    var n = labelNode(btn);
    if (!n) return;
    if (!btn.hasAttribute('data-fl-label-orig')) btn.setAttribute('data-fl-label-orig', n.textContent);
    n.textContent = text != null ? text : btn.getAttribute('data-fl-label-orig');
  }
  function codeOfBtn(btn, attr) { return norm(btn.getAttribute(attr) || cfg.code || ''); }

  /* applied = « Appliqué ✓ » ; saved (panier vide) = « Enregistré ✓ » ; idle = libellé d'origine.
     Le statut voisin suit : vidé quand le code est retiré, expliqué quand le code attend un article. */
  function markState(btn, state) {
    var prev = btn.getAttribute('data-fl-state') || 'idle';
    btn.classList.toggle('fl-is-applied', state === 'applied');
    btn.classList.toggle('fl-is-saved', state === 'saved');
    btn.setAttribute('data-fl-state', state);
    setLabel(btn, state === 'applied' ? t('btnApplied') : (state === 'saved' ? t('btnSaved') : null));
    if (prev === state || btn.getAttribute('aria-busy') === 'true') return;
    var status = findNear(btn, '[data-fl-apply-status]');
    if (!status) return;
    var code = codeOfBtn(btn, 'data-fl-apply-code');
    if (state === 'idle') {
      status.textContent = '';
      status.removeAttribute('data-fl-state');
    } else if (state === 'saved') {
      if (!status.textContent) say(status, t('msgSavedShort', code), 'info');
    } else if (prev === 'saved') {
      say(status, t('msgApplied', code), 'success');
    }
  }
  function syncButtons(cart) {
    if (!cart) return;
    each(document.querySelectorAll('[data-fl-apply-code]'), function (btn) {
      markState(btn, codeState(cart, codeOfBtn(btn, 'data-fl-apply-code')));
    });
  }

  function fillDelivery(el) {
    var est = estimate(cfg.country);
    el.textContent = el.getAttribute('data-fl-delivery') === 'range' ? est.range : est.text;
    if (est.note) el.setAttribute('title', est.note);
  }

  function scan(scope) {
    scope = scope || document;
    each(scope.querySelectorAll('[data-fl-delivery]'), fillDelivery);
    each(scope.querySelectorAll('[data-fl-apply-status], [data-fl-copy-status]'), prepLive);
    if (lastCart) syncButtons(lastCart);
  }

  function onApplyClick(btn) {
    if (btn.getAttribute('aria-busy') === 'true') return;
    var code = codeOfBtn(btn, 'data-fl-apply-code');
    var status = findNear(btn, '[data-fl-apply-status]') || liveRegion();
    btn.setAttribute('aria-busy', 'true');
    btn.classList.add('fl-is-busy');
    applyCode(code).then(function (res) {
      btn.removeAttribute('aria-busy');
      btn.classList.remove('fl-is-busy');
      say(status, res.message, stateOf(res));
      if (lastCart) markState(btn, codeState(lastCart, code));
    });
  }

  function copyText(text, near) {
    function legacy() {
      return new Promise(function (resolve, reject) {
        var back = document.activeElement;
        var ta = document.createElement('textarea');
        ta.value = text;
        ta.setAttribute('readonly', '');
        ta.setAttribute('aria-hidden', 'true');
        ta.style.cssText = 'position:fixed;top:0;left:0;width:1px;height:1px;opacity:0;pointer-events:none;';
        (near && near.parentNode ? near.parentNode : document.body).appendChild(ta);
        ta.select();
        var ok = false;
        try { ok = document.execCommand('copy'); } catch (e) {}
        ta.parentNode.removeChild(ta);
        if (back && back.focus) { try { back.focus({ preventScroll: true }); } catch (e) {} }
        if (ok) resolve(); else reject(new Error('copy'));
      });
    }
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text).catch(legacy);
    }
    return legacy();
  }
  function onCopyClick(btn) {
    var code = codeOfBtn(btn, 'data-fl-copy');
    if (!code) return;
    var status = findNear(btn, '[data-fl-copy-status]') || findNear(btn, '[data-fl-apply-status]') || liveRegion();
    copyText(code, btn).then(function () {
      btn.classList.add('fl-is-copied');
      setLabel(btn, t('btnCopied'));
      say(status, t('msgCopied', code), 'success');
      clearTimeout(btn.__flCopyTimer);
      btn.__flCopyTimer = setTimeout(function () {
        btn.classList.remove('fl-is-copied');
        setLabel(btn, null);
      }, 2500);
    }, function () {
      say(status, t('msgCopyFail', code), 'info');
    });
  }

  document.addEventListener('click', function (e) {
    var target = e.target && e.target.closest ? e.target : null;
    if (!target) return;
    var apply = target.closest('[data-fl-apply-code]');
    if (apply) { e.preventDefault(); onApplyClick(apply); return; }
    var copy = target.closest('[data-fl-copy]');
    if (copy) { e.preventDefault(); onCopyClick(copy); }
  });

  /* ---------- Tiroir panier ---------- */
  var drawer = null;
  var ui = null;
  var drawerObs = null;
  var openObs = null;
  var moQueued = false;
  var lastTotalText = null;
  var refreshTimer = 0;
  var inputFocused = false;
  var fieldOp = 0;
  var drawerOn = !!(modules.drawerCode || modules.drawerCodeLines || modules.delivery || modules.trust);

  var SVG_NS = 'http://www.w3.org/2000/svg';
  /* Icônes au trait (24 × 24), couleur héritée. */
  var ICONS = {
    calendar: ['M4 6.5h16v13.5H4z', 'M4 10.5h16', 'M8.5 3.5v4', 'M15.5 3.5v4'],
    lock: ['M6 10.5h12v9.5H6z', 'M8.5 10.5V7.8a3.5 3.5 0 0 1 7 0v2.7', 'M12 14.2v2.4'],
    returns: ['M9 8.5H5.5V5', 'M5.8 8.3A7.5 7.5 0 1 1 4.6 13'],
    box: ['M3.8 7.6 12 3.5l8.2 4.1v8.8L12 20.5l-8.2-4.1z', 'M3.8 7.6 12 11.7l8.2-4.1', 'M12 11.7v8.8'],
    tag: ['M3.5 12.3V4.5a1 1 0 0 1 1-1h7.8l8.2 8.2-8.8 8.8z', 'M8 8h.01'],
    close: ['M7 7l10 10', 'M17 7 7 17']
  };
  function icon(name, cls) {
    var svg = document.createElementNS(SVG_NS, 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('width', '24');
    svg.setAttribute('height', '24');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('stroke', 'currentColor');
    svg.setAttribute('stroke-width', '1.6');
    svg.setAttribute('stroke-linecap', 'round');
    svg.setAttribute('stroke-linejoin', 'round');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    if (cls) svg.setAttribute('class', cls);
    (ICONS[name] || []).forEach(function (d) {
      var p = document.createElementNS(SVG_NS, 'path');
      p.setAttribute('d', d);
      svg.appendChild(p);
    });
    return svg;
  }
  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  var uid = 0;
  function buildUI() {
    var parts = {};
    var id = 'fl-cv-' + (++uid);

    if (modules.drawerCode || modules.drawerCodeLines) {
      /* Lignes des codes appliqués (toujours) et message (role=status). Avec le champ
         (modules.drawerCode) : lien « Vous avez un code promo ? » et panneau, replié par défaut. */
      var box = el('div', 'fl-cv-code');
      box.setAttribute('data-fl-cv', 'code');
      var list = el('ul', 'fl-cv-applied');
      list.setAttribute('aria-label', t('appliedList'));
      var msg = el('p', 'fl-cv-code__msg');
      msg.id = id + '-msg';
      msg.setAttribute('role', 'status');
      msg.setAttribute('aria-live', 'polite');
      box.appendChild(list);

      if (modules.drawerCode) {
        var toggle = el('button', 'fl-cv-code__toggle', t('codeToggle'));
        toggle.type = 'button';
        toggle.setAttribute('aria-expanded', 'false');
        toggle.setAttribute('aria-controls', id + '-panel');
        var panel = el('div', 'fl-cv-code__panel');
        panel.id = id + '-panel';
        panel.hidden = true;
        var row = el('div', 'fl-cv-code__row');
        var label = el('label', 'fl-cv-code__label fl-cv-sr', t('codeLabel'));
        label.setAttribute('for', id + '-input');
        var input = el('input', 'fl-cv-code__input');
        input.id = id + '-input';
        input.type = 'text';
        input.name = 'fl_discount_code';
        input.setAttribute('autocomplete', 'off');
        input.setAttribute('autocapitalize', 'characters');
        input.setAttribute('autocorrect', 'off');
        input.setAttribute('spellcheck', 'false');
        input.setAttribute('enterkeyhint', 'go');
        input.setAttribute('maxlength', '64');
        input.setAttribute('placeholder', t('codeLabel'));
        input.setAttribute('aria-describedby', id + '-msg');
        var btn = el('button', 'fl-cv-code__btn', t('codeApply'));
        btn.type = 'button';
        row.appendChild(label);
        row.appendChild(input);
        row.appendChild(btn);
        panel.appendChild(row);
        box.appendChild(toggle);
        box.appendChild(panel);

        toggle.addEventListener('click', function () {
          if (panel.hidden) openPanel(true); else closePanel(false);
        });
        btn.addEventListener('click', function () { submitCode(); });
        input.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' && !e.isComposing) { e.preventDefault(); submitCode(); }
          else if (e.key === 'Escape' && !e.isComposing) { e.preventDefault(); e.stopPropagation(); closePanel(true); }
        });
        input.addEventListener('focus', function () { inputFocused = true; });
        input.addEventListener('blur', function () { inputFocused = false; });

        parts.toggle = toggle;
        parts.panel = panel;
        parts.input = input;
        parts.btn = btn;
      }
      box.appendChild(msg);

      list.addEventListener('click', function (e) {
        var x = e.target.closest && e.target.closest('[data-fl-cv-remove]');
        if (!x || x.getAttribute('aria-busy') === 'true') return;
        x.setAttribute('aria-busy', 'true');
        var code = x.getAttribute('data-fl-cv-remove');
        fieldOp++;
        removeCode(code).then(function (res) {
          fieldOp--;
          say(msg, res.message, res.ok ? 'success' : 'error');
          /* Le bouton × disparaît avec sa ligne : le focus revient au lien du champ (ou au paiement). */
          if (!x.isConnected) focusAfterChange();
          else x.removeAttribute('aria-busy');
        });
      });

      parts.code = box;
      parts.list = list;
      parts.msg = msg;
    }

    if (modules.delivery) {
      /* Livraison estimée : au-dessus de Checkout+ et du bouton de paiement. */
      var est = estimate(cfg.country);
      var etaWrap = el('div', 'fl-cv-reassure fl-cv-reassure--eta');
      etaWrap.setAttribute('data-fl-cv', 'eta');
      var eta = el('p', 'fl-cv-eta');
      eta.setAttribute('title', est.note);
      eta.appendChild(icon('calendar', 'fl-cv-eta__icon'));
      var etaText = el('span', 'fl-cv-eta__text');
      etaText.appendChild(el('span', 'fl-cv-eta__label', est.label));
      etaText.appendChild(document.createTextNode(' '));
      etaText.appendChild(el('span', 'fl-cv-eta__dates', est.range));
      eta.appendChild(etaText);
      eta.appendChild(el('span', 'fl-cv-sr', ' (' + est.note + ')'));
      etaWrap.appendChild(eta);
      parts.eta = etaWrap;
    }
    if (modules.trust) {
      /* Confiance : juste sous le bouton de paiement, au-dessus des logos de paiement. */
      var trustWrap = el('div', 'fl-cv-reassure fl-cv-reassure--trust');
      trustWrap.setAttribute('data-fl-cv', 'trust');
      var ul = el('ul', 'fl-cv-trust');
      ul.setAttribute('aria-label', t('trustList'));
      [['lock', 'trustSecure'], ['returns', 'trustReturns'], ['box', 'trustShip']].forEach(function (it) {
        var li = el('li', 'fl-cv-trust__item');
        li.appendChild(icon(it[0], 'fl-cv-trust__icon'));
        li.appendChild(el('span', null, t(it[1])));
        ul.appendChild(li);
      });
      trustWrap.appendChild(ul);
      parts.trust = trustWrap;
    }
    return parts;
  }

  function openPanel(focus) {
    if (!ui || !ui.panel) return;
    ui.panel.hidden = false;
    ui.code.classList.add('is-open');
    ui.toggle.setAttribute('aria-expanded', 'true');
    if (focus) { try { ui.input.focus({ preventScroll: true }); } catch (e) {} }
  }
  function closePanel(returnFocus) {
    if (!ui || !ui.panel) return;
    var inside = ui.panel.contains(document.activeElement);
    ui.panel.hidden = true;
    ui.code.classList.remove('is-open');
    ui.toggle.setAttribute('aria-expanded', 'false');
    /* Une erreur ne reste pas affichée sous un champ replié. */
    if (ui.msg.getAttribute('data-fl-state') === 'error') {
      ui.msg.textContent = '';
      ui.msg.removeAttribute('data-fl-state');
      ui.input.removeAttribute('aria-invalid');
    }
    if (returnFocus || inside) focusAfterChange();
  }
  /* Focus après un ajout / retrait / fermeture : la puce du code (bouton ×), sinon le lien. */
  function focusAfterChange(code) {
    if (!ui || !ui.list) return;
    var target = null;
    if (code) {
      each(ui.list.querySelectorAll('[data-fl-cv-remove]'), function (x) {
        if (!target && same(x.getAttribute('data-fl-cv-remove'), code)) target = x;
      });
    }
    if (!target && (!ui.toggle || getComputedStyle(ui.toggle).display === 'none')) target = ui.list.querySelector('[data-fl-cv-remove]');
    /* Sans champ (lignes seules) : le bouton de paiement. */
    target = target || ui.toggle || (drawer && drawer.querySelector('[data-cd-checkout]'));
    if (!target) return;
    try { target.focus({ preventScroll: true }); } catch (e) {}
  }

  function submitCode() {
    if (!ui || !ui.input) return;
    if (ui.btn.getAttribute('aria-busy') === 'true') return;
    var code = norm(ui.input.value);
    if (!code) {
      say(ui.msg, t('msgEmpty'), 'error');
      ui.input.setAttribute('aria-invalid', 'true');
      openPanel(true);
      return;
    }
    ui.btn.setAttribute('aria-busy', 'true');
    ui.btn.classList.add('fl-is-busy');
    fieldOp++;
    applyCode(code).then(function (res) {
      fieldOp--;
      ui.btn.removeAttribute('aria-busy');
      ui.btn.classList.remove('fl-is-busy');
      ui.input.setAttribute('aria-invalid', res.ok ? 'false' : 'true');
      say(ui.msg, res.message, stateOf(res));
      if (res.ok) {
        ui.input.value = '';
        /* Succès : le champ se replie, le focus passe à la puce du code. */
        ui.panel.hidden = true;
        ui.code.classList.remove('is-open');
        ui.toggle.setAttribute('aria-expanded', 'false');
        focusAfterChange(res.code);
      } else {
        openPanel(false);
      }
    });
  }

  function renderApplied(cart) {
    if (!ui || !ui.list || !cart) return;
    var list = ui.list;
    var rows = ((cart.discount_codes) || []).filter(function (d) { return d && d.code; }).map(function (d) {
      return { code: d.code, applicable: !!d.applicable, amount: d.applicable ? savingOf(cart, d.code) : 0 };
    });
    var has = rows.some(function (d) { return d.applicable; });
    ui.code.classList.toggle('has-code', has);
    /* Signature = ce qui est affiché (montants et format compris) : on ne redessine que si ça change. */
    var f = drawerFormat();
    var sig = JSON.stringify([rows, cart.currency, f && [f.pre, f.dec, f.th, f.suf]]);
    if (list.getAttribute('data-sig') === sig) return;
    list.setAttribute('data-sig', sig);
    /* Le focus sur un × survit au redessin. */
    var act = document.activeElement;
    var focusCode = act && list.contains(act) ? act.getAttribute('data-fl-cv-remove') : null;
    while (list.firstChild) list.removeChild(list.firstChild);
    rows.forEach(function (d) {
      var li = el('li', 'fl-cv-applied__row' + (d.applicable ? '' : ' is-inactive'));
      var lab = el('span', 'fl-cv-applied__label');
      lab.appendChild(icon('tag', 'fl-cv-applied__icon'));
      /* Le montant d'un code actif est deja compris dans la ligne « discounts » du tiroir :
         la ligne se lit « dont MISSYOU10 », pas comme un second rabais a soustraire. */
      lab.appendChild(el('span', 'fl-cv-applied__name', t(d.applicable && T.discountIncl ? 'discountIncl' : 'discountLine', d.code)));
      var x = el('button', 'fl-cv-applied__x');
      x.type = 'button';
      x.setAttribute('data-fl-cv-remove', d.code);
      x.setAttribute('aria-label', t('codeRemove', d.code));
      x.appendChild(icon('close'));
      lab.appendChild(x);
      li.appendChild(lab);
      var val = el('span', 'fl-cv-applied__amt');
      if (!d.applicable) val.textContent = t('notApplied');
      else if (d.amount > 0) val.appendChild(moneyNodes(d.amount, '−'));
      li.appendChild(val);
      list.appendChild(li);
    });
    if (focusCode) focusAfterChange(focusCode);
  }

  function clearFieldMsg() {
    if (fieldOp || !ui || !ui.msg) return;
    ui.msg.textContent = '';
    ui.msg.removeAttribute('data-fl-state');
    if (ui.input) ui.input.removeAttribute('aria-invalid');
  }
  document.addEventListener('fl:code-applied', clearFieldMsg);
  document.addEventListener('fl:code-removed', clearFieldMsg);

  function publish(cart) {
    lastCart = cart;
    renderApplied(cart);
    syncButtons(cart);
    fixShipBar();
  }

  function refreshState() {
    return fetchCart().then(function (c) { publish(c); return c; }).catch(function () { return null; });
  }
  function scheduleRefresh() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(refreshState, 300);
  }

  function isOpen() {
    return !!drawer && (drawer.classList.contains('is-open') || drawer.getAttribute('aria-hidden') === 'false');
  }

  /* Police et rayon repris du tiroir : Montserrat des totaux, rayon du bouton de paiement. */
  function syncLook(footer) {
    var tot = footer.querySelector('[data-cd-total]');
    var co = footer.querySelector('[data-cd-checkout]');
    var font = tot ? getComputedStyle(tot).fontFamily : '';
    var radius = co ? getComputedStyle(co).borderTopLeftRadius : '';
    [ui.code, ui.eta, ui.trust].forEach(function (n) {
      if (!n) return;
      if (font && n.style.getPropertyValue('--fl-cv-font') !== font) n.style.setProperty('--fl-cv-font', font);
      if (radius && n.style.getPropertyValue('--fl-cv-radius') !== radius) n.style.setProperty('--fl-cv-radius', radius);
    });
  }

  /* Enfant direct de parent qui contient sel (ou null). */
  function childWith(parent, sel) {
    var n = parent.querySelector(sel);
    while (n && n.parentNode !== parent) n = n.parentNode;
    return n;
  }

  /* Place (ou replace) nos blocs dans le pied de page du tiroir, sans jamais les recréer :
     la saisie en cours est conservée. Rien ne bouge quand tout est déjà en place, donc
     l'observateur de mutations ne boucle pas. */
  function ensureDrawerUI() {
    if (!drawer || !ui) return;
    var footer = drawer.querySelector('[data-cd-footer]');
    if (!footer) return;
    if (ui.code) {
      /* Codes appliqués : sous la ligne des rabais, juste au-dessus du total. */
      var tot = childWith(footer, '[data-cd-total]');
      var moved = false;
      if (tot) {
        if (ui.code.nextElementSibling !== tot) { footer.insertBefore(ui.code, tot); moved = true; }
      } else if (!footer.contains(ui.code)) {
        footer.insertBefore(ui.code, footer.firstChild);
        moved = true;
      }
      if (moved && inputFocused && ui.input) { try { ui.input.focus({ preventScroll: true }); } catch (e) {} }
    }
    var co = footer.querySelector(':scope > [data-cd-checkout]');
    if (ui.eta) {
      /* Livraison estimée : au-dessus de Checkout+ (à défaut, du bouton de paiement). */
      var before = footer.querySelector(':scope > [data-cd-plus-slot]') || co;
      if (before && ui.eta.nextElementSibling !== before) footer.insertBefore(ui.eta, before);
      else if (!before && !footer.contains(ui.eta)) footer.appendChild(ui.eta);
    }
    if (ui.trust) {
      /* Confiance : juste sous le bouton de paiement, au-dessus des logos de paiement. */
      if (co && ui.trust.previousElementSibling !== co) footer.insertBefore(ui.trust, co.nextSibling);
      else if (!co && !footer.contains(ui.trust)) footer.appendChild(ui.trust);
    }
    if (ui.code && !footer.classList.contains('fl-cv-on')) footer.classList.add('fl-cv-on');
    syncLook(footer);
  }

  function onDrawerMutated() {
    if (!drawer) return;
    if (!drawer.isConnected) { attachDrawer(); return; }
    ensureDrawerUI();
    var tot = drawer.querySelector('[data-cd-checkout-total]') || drawer.querySelector('[data-cd-total]');
    var txt = tot ? tot.textContent : '';
    if (txt !== lastTotalText) {
      lastTotalText = txt;
      if (isOpen()) scheduleRefresh();
    }
    fixShipBar();
  }

  function attachDrawer() {
    if (drawerObs) { drawerObs.disconnect(); drawerObs = null; }
    if (openObs) { openObs.disconnect(); openObs = null; }
    drawer = document.querySelector('[data-cd-drawer]');
    if (!drawer || !drawerOn) return;
    if (!ui) ui = buildUI();
    ensureDrawerUI();
    /* Un seul passage par image, quel que soit le nombre de mutations (pas de boucle :
       nos propres ajouts ne changent pas le total, donc ne relancent rien). */
    drawerObs = new MutationObserver(function () {
      if (moQueued) return;
      moQueued = true;
      requestAnimationFrame(function () { moQueued = false; onDrawerMutated(); });
    });
    drawerObs.observe(drawer, { childList: true, subtree: true });
    openObs = new MutationObserver(function () { if (isOpen()) refreshState(); });
    openObs.observe(drawer, { attributes: true, attributeFilter: ['aria-hidden'] });
    if (isOpen()) refreshState();
  }

  /* ---------- API publique ---------- */
  var config = {
    code: cfg.code || '',
    pct: cfg.pct || 0,
    country: cfg.country || 'CA',
    locale: cfg.locale || 'en',
    currency: cfg.currency || 'CAD',
    freeShipThreshold: cfg.freeShipThreshold || 0,
    freeShipCurrency: cfg.freeShipCurrency || 'CAD',
    freeShipCountries: (cfg.freeShipCountries || []).slice(),
    modules: {
      drawerCode: !!modules.drawerCode, drawerCodeLines: !!modules.drawerCodeLines, delivery: !!modules.delivery, trust: !!modules.trust,
      pdpOffer: !!modules.pdpOffer, exitOffer: !!modules.exitOffer
    }
  };
  try { Object.freeze(config.modules); Object.freeze(config.freeShipCountries); Object.freeze(config); } catch (e) {}

  var api = {
    __fl: 1,
    version: '1.1.0',
    config: config,
    applyCode: applyCode,
    removeCode: removeCode,
    estimate: estimate,
    getCart: function () { return fetchCart().then(function (c) { publish(c); return c; }); },
    scan: scan,
    ready: function (cb) {
      if (typeof cb !== 'function') return;
      Promise.resolve().then(function () { cb(api); });
    }
  };

  var early = window.FLConv;
  window.FLConv = api;

  /* ---------- Démarrage ---------- */
  function boot() {
    scan(document);
    attachDrawer();
    /* État initial (codes déjà dans le panier) seulement si un bouton d'offre est dans la page.
       La région de secours existe avant le premier message : il est alors bien annoncé. */
    if (document.querySelector('[data-fl-apply-code], [data-fl-copy]')) liveRegion();
    if (document.querySelector('[data-fl-apply-code]')) refreshState();
    if (window.Shopify && Shopify.designMode) {
      document.addEventListener('shopify:section:load', function () { scan(document); attachDrawer(); });
    }
    /* Rappels enregistrés avant notre chargement. */
    var q = [].concat((early && early._q) || [], window.FLConvQ || []);
    window.FLConvQ = { push: function (cb) { api.ready(cb); } };
    q.forEach(function (cb) { api.ready(cb); });
    emit('fl:conv-ready', api);
  }

  if (document.prerendering) {
    document.addEventListener('prerenderingchange', boot, { once: true });
  } else if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
